import React from 'react';
import { palette } from '../../styles/theme';

export const DisableAppSVG = ({ className = '', selected = false }) => {
    return (
        <span className={className}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_6546_9841)">
                    <path d="M9.54533 4.24667C9.88667 4.088 10.2653 4 10.6667 4H21.3333C22.0406 4 22.7189 4.28095 23.219 4.78105C23.719 5.28115 24 5.95942 24 6.66667V18.6667M24 24V25.3333C24 26.0406 23.719 26.7189 23.219 27.219C22.7189 27.719 22.0406 28 21.3333 28H10.6667C9.95942 28 9.28115 27.719 8.78105 27.219C8.28095 26.7189 8 26.0406 8 25.3333V8" stroke={palette.secondary.main} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14.6667 5.33301H17.3334" stroke={palette.secondary.main} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4 4L28 28" stroke={palette.secondary.main} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 22.667V22.6803" stroke={palette.secondary.main} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_6546_9841">
                        <rect width="32" height="32" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        </span>
    );
};
